import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
// routes
import { PATH_DASHBOARD } from '../routes/paths';

// ----------------------------------------------------------------------

OnboardingGuard.propTypes = {
  children: PropTypes.node
};

export default function OnboardingGuard({ children }) {
  const { isOnboarded } = useSelector((state) => state.app);

  if (isOnboarded) {
    return <Navigate to={PATH_DASHBOARD.root} />;
  }

  return <>{children}</>;
}
